import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AnswerFrequencySummary;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { fromJS } from 'immutable';
import { scaleLinear } from 'd3-scale';
import { IconXSolid, IconCheckSolid } from '@instructure/ui-icons';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Table } from '@instructure/ui-table';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
export var AnswerFrequencySummary = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_AnswerFrequencySummary = /*#__PURE__*/function (_Component) {
  function AnswerFrequencySummary() {
    var _this2;
    _classCallCheck(this, AnswerFrequencySummary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, AnswerFrequencySummary, [].concat(args));
    _defineProperty(_this2, "renderAnswerTableRow", function (choiceInfo, choiceIndex) {
      var choiceSum = _this2.props.itemAnalysis.choiceCountSum();
      var choiceBody = _this2.renderChoiceBody(choiceInfo);
      return jsx(Table.Row, {
        key: choiceIndex
      }, jsx(Table.Cell, null, _this2.isCorrect(choiceInfo) ? jsx(IconCheckSolid, null) : jsx(IconXSolid, null), jsx(ScreenReaderContent, null, _this2.getBarTitle(choiceInfo))), jsx(Table.RowHeader, null, jsx("span", {
        "data-testid": "answer-textfield",
        title: choiceBody
      }, choiceBody)), jsx(Table.Cell, null, t.number(Math.floor(choiceInfo.get('choiceCount')))), jsx(Table.Cell, null, choiceSum > 0 ? t.number(choiceInfo.get('choiceCount') / choiceSum, 'percent') : 0), jsx(Table.Cell, {
        "aria-hidden": "true"
      }, _this2.renderBarPlot(choiceInfo)));
    });
    return _this2;
  }
  _inherits(AnswerFrequencySummary, _Component);
  return _createClass(AnswerFrequencySummary, [{
    key: "getBarStyles",
    value: function getBarStyles(choiceInfo) {
      var highest = this.props.itemAnalysis.choiceCountMax();
      var xScale = scaleLinear() // linear scale against domain, range
      .domain([highest, 0]) // bounds
      .range([100, 0]); // to percent of column width
      return {
        width: "".concat(xScale(choiceInfo.get('choiceCount')), "%")
      };
    }
  }, {
    key: "isCorrect",
    value: function isCorrect(choiceInfo) {
      return choiceInfo !== this.unansweredChoiceInfo && choiceInfo.get('correct');
    }
  }, {
    key: "getBarTitle",
    value: function getBarTitle(choiceInfo) {
      return this.isCorrect(choiceInfo) ? t('Correct Answer') : t('Incorrect Answer');
    }
  }, {
    key: "renderBarPlot",
    value: function renderBarPlot(choiceInfo) {
      var barStyles = this.isCorrect(choiceInfo) ? [this.props.styles.barCorrect, this.props.styles.bar] : [this.props.styles.bar];
      return jsx("div", {
        "data-testid": "bar",
        css: barStyles,
        style: this.getBarStyles(choiceInfo),
        alt: t('Graph bar'),
        title: this.getBarTitle(choiceInfo)
      });
    }
  }, {
    key: "renderChoiceBody",
    value: function renderChoiceBody(choiceInfo) {
      var text = extractTextFromHtml(choiceInfo.get('itemBody'));
      if (text.length > 0) return text;
      return this.getBarTitle(choiceInfo);
    }
  }, {
    key: "render",
    value: function render() {
      var choiceInfo = this.props.itemAnalysis.choiceInfo();
      this.unansweredChoiceInfo = fromJS({
        itemBody: t('(No answer)'),
        choiceCount: this.props.itemAnalysis.unansweredInfo()
      });
      return jsx("div", {
        css: this.props.styles.content,
        "data-automation": "sdk-reporting-frequency-summary"
      }, jsx(Table, {
        caption: t('Answer Frequency Summary')
      }, jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: "answer-frequency-summary-is-correct"
      }, jsx(ScreenReaderContent, null, t('Is Correct?'))), jsx(Table.ColHeader, {
        id: "answer-frequency-sumary-answer"
      }, t('Answer')), jsx(Table.ColHeader, {
        id: "answer-frequency-summary-respondents"
      }, t('Respondents')), jsx(Table.ColHeader, {
        id: "answer-frequency-summary-answer-ratio"
      }, t('Percentage')))), jsx(Table.Body, null, choiceInfo.toArray().map(this.renderAnswerTableRow), this.renderAnswerTableRow(this.unansweredChoiceInfo, choiceInfo.size))));
    }
  }]);
}(Component), _defineProperty(_AnswerFrequencySummary, "displayName", 'AnswerFrequencySummary'), _defineProperty(_AnswerFrequencySummary, "componentId", "Quizzes".concat(_AnswerFrequencySummary.displayName)), _defineProperty(_AnswerFrequencySummary, "propTypes", {
  itemAnalysis: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object
}), _AnswerFrequencySummary)) || _class);
export default AnswerFrequencySummary;